import * as Yup from 'yup';

const MAX_TITLE_LENGTH = 64;

export const validationSchema = (lang: string) =>
  Yup.object().shape({
    title: Yup.object().shape({
      [lang]: Yup.string()
        .required('validation.title')
        .max(MAX_TITLE_LENGTH, 'validation.titleMax'),
    }),
    content: Yup.object().shape({
      [lang]: Yup.string().required('validation.content'),
    }),
  });
